var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import { css } from 'styled-components';
import "../../enums/accordion.js";
import "../../enums/alert.js";
import "../../enums/avatar.js";
import "../../enums/breakpoints.js";
import { ButtonSizes } from "../../enums/button.js";
import "../../enums/code-editor.js";
import "../../enums/colors.js";
import "../../enums/combobox.js";
import "../../enums/date.js";
import "../../enums/drag-and-drop.js";
import "../../enums/dialog.js";
import "../../enums/divider.js";
import "../../enums/dropdown.js";
import "../../enums/fieldset.js";
import "../../enums/font-icon.js";
import "../../enums/fonts.js";
import "../../enums/headings.js";
import "../../enums/input.js";
import "../../enums/keys.js";
import "../../enums/list.js";
import "../../enums/listbox.js";
import "../../enums/loader.js";
import "../../enums/margin.js";
import "../../enums/option.js";
import "../../enums/pill.js";
import "../../enums/placements.js";
import "../../enums/popout.js";
import "../../enums/privacy.js";
import "../../enums/radio-group.js";
import "../../enums/status.js";
import "../../enums/switch.js";
import "../../enums/table.js";
import "../../enums/tooltip.js";
import "../../enums/transitions.js";
import "../../enums/widths.js";
import "../../themes/alert.js";
import { borderRadiusMedium } from "../../themes/borders.js";
import "../../themes/button.js";
import "../../themes/checkbox.js";
import "../../themes/divider.js";
import "../../themes/dropdown.js";
import "../../themes/fieldset.js";
import { fontFamilyBook } from "../../themes/fonts.js";
import "../../themes/input.js";
import "../../themes/list.js";
import "../../themes/listbox.js";
import "../../themes/loader.js";
import "../../themes/option.js";
import "../../themes/popout.js";
import "../../themes/switch.js";
import "../../themes/themes.js";
import "../../themes/tooltip.js";
import { mediaPrefersReducedMotion } from "./media-queries.js";
var baseButtonStyle = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  align-items: center;\n  appearance: none;\n  background-color: transparent;\n  border-color: transparent;\n  border-radius: ", "px;\n  border-style: solid;\n  border-width: 1px;\n  box-sizing: border-box;\n  color: #000;\n  cursor: pointer;\n  display: inline-flex;\n  flex-direction: row;\n  flex-shrink: 0;\n  font-family: ", ";\n  font-size: 14px;\n  justify-content: center;\n  line-height: 22px;\n  min-height: 50px;\n  padding: 13px 20px;\n  text-decoration: none;\n  transition:\n    background-color 0.2s ease,\n    border-color 0.2s ease,\n    color 0.2s ease,\n    outline 0.1s ease;\n  vertical-align: top;\n  ", "\n\n  &:focus {\n    outline: 0;\n  }\n\n  &:focus-visible {\n    outline-color: #000;\n    outline-offset: ", ";\n    outline-style: ", ";\n    outline-width: ", ";\n  }\n\n  &[aria-disabled='true'] {\n    cursor: not-allowed;\n  }\n"])), borderRadiusMedium, fontFamilyBook, mediaPrefersReducedMotion, function (_ref) {
  var theme = _ref.theme;
  return "".concat(theme.outline.offset, "px");
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.outline.style;
}, function (_ref3) {
  var theme = _ref3.theme;
  return "".concat(theme.outline.width, "px");
});
var iconButtonStyle = css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  align-items: center;\n  appearance: none;\n  background-color: transparent;\n  border-color: transparent;\n  border-radius: ", "px;\n  border-style: solid;\n  border-width: 1px;\n  box-sizing: border-box;\n  cursor: pointer;\n  display: inline-flex;\n  flex-direction: row;\n  flex-shrink: 0;\n  justify-content: center;\n  padding: 10px;\n  text-decoration: none;\n  transition:\n    background-color 0.2s ease,\n    border-color 0.2s ease,\n    color 0.2s ease,\n    outline 0.1s ease;\n  vertical-align: top;\n  ", "\n\n  &:focus {\n    outline: 0;\n  }\n\n  &:focus-visible {\n    outline-color: transparent;\n    outline-offset: ", ";\n    outline-style: ", ";\n    outline-width: ", ";\n  }\n\n  &[aria-disabled='true'] {\n    cursor: not-allowed;\n  }\n"])), borderRadiusMedium, mediaPrefersReducedMotion, function (_ref4) {
  var theme = _ref4.theme;
  return "".concat(theme.outline.offset, "px");
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.outline.style;
}, function (_ref6) {
  var theme = _ref6.theme;
  return "".concat(theme.outline.width, "px");
});
/**
 * Get Styled Component button theme
 * @param options GetButtonThemeOptions
 * @returns ThemedCssFunction<DefaultTheme>
 */
var getButtonTheme = function getButtonTheme(options) {
  var look = options.look;
  return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    background-color: ", ";\n    border-color: ", ";\n    color: ", ";\n\n    &:hover {\n      background-color: ", ";\n      border-color: ", ";\n      color: ", ";\n    }\n\n    &:active {\n      background-color: ", ";\n      border-color: ", ";\n      color: ", ";\n    }\n\n    &:focus-visible {\n      background-color: ", ";\n      border-color: ", ";\n      color: ", ";\n      outline-color: ", ";\n    }\n\n    &[aria-disabled='true'] {\n      background-color: ", ";\n      border-color: ", ";\n      color: ", ";\n    }\n\n    &[aria-expanded='true'] {\n      background-color: ", ";\n      border-color: ", ";\n      color: ", ";\n    }\n  "])), function (_ref7) {
    var theme = _ref7.theme;
    return theme.button[look].backgroundColor;
  }, function (_ref8) {
    var theme = _ref8.theme;
    return theme.button[look].borderColor;
  }, function (_ref9) {
    var theme = _ref9.theme;
    return theme.button[look].textColor;
  }, function (_ref10) {
    var theme = _ref10.theme;
    return theme.button[look].backgroundColorHover;
  }, function (_ref11) {
    var theme = _ref11.theme;
    return theme.button[look].borderColorHover;
  }, function (_ref12) {
    var theme = _ref12.theme;
    return theme.button[look].textColorHover;
  }, function (_ref13) {
    var theme = _ref13.theme;
    return theme.button[look].backgroundColorActive;
  }, function (_ref14) {
    var theme = _ref14.theme;
    return theme.button[look].borderColorActive;
  }, function (_ref15) {
    var theme = _ref15.theme;
    return theme.button[look].textColorActive;
  }, function (_ref16) {
    var theme = _ref16.theme;
    return theme.button[look].backgroundColorFocus;
  }, function (_ref17) {
    var theme = _ref17.theme;
    return theme.button[look].borderColorFocus;
  }, function (_ref18) {
    var theme = _ref18.theme;
    return theme.button[look].textColorFocus;
  }, function (_ref19) {
    var theme = _ref19.theme;
    return theme.button[look].outlineColorFocus;
  }, function (_ref20) {
    var theme = _ref20.theme;
    return theme.button[look].backgroundColorDisabled;
  }, function (_ref21) {
    var theme = _ref21.theme;
    return theme.button[look].borderColorDisabled;
  }, function (_ref22) {
    var theme = _ref22.theme;
    return theme.button[look].textColorDisabled;
  }, function (_ref23) {
    var theme = _ref23.theme;
    return theme.button[look].backgroundColorHover;
  }, function (_ref24) {
    var theme = _ref24.theme;
    return theme.button[look].borderColorHover;
  }, function (_ref25) {
    var theme = _ref25.theme;
    return theme.button[look].textColorHover;
  });
};
/**
 * Get Styled Component button theme
 * @param options GetButtonWidthOptions
 * @returns ThemedCssFunction<DefaultTheme>
 */
var getButtonWidth = function getButtonWidth(options) {
  var fullWidth = options.fullWidth,
    size = options.size;
  if (fullWidth) {
    return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n      width: 100%;\n    "])));
  } else switch (size) {
    case ButtonSizes.Large:
      {
        return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n          min-width: 225px;\n        "])));
      }
    case ButtonSizes.Medium:
      {
        return css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n          min-width: 175px;\n        "])));
      }
    case ButtonSizes.Small:
      {
        return css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n          min-width: 125px;\n        "])));
      }
    case ButtonSizes.XSmall:
      {
        return css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n          min-width: 75px;\n        "])));
      }
  }
  return '';
};
export { baseButtonStyle, getButtonTheme, getButtonWidth, iconButtonStyle };